"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stepSchema = exports.StepDefinitions = exports.TestAndMockStepDefinitions = exports.TestStepDefinitions = exports.AbortReason = exports.WizardUsers = void 0;
const z = require("zod");
const test_extract_signals_1 = require("./steps/test/test-extract-signals");
const test_extract_pinout_1 = require("./steps/test/test-extract-pinout");
const adjudication_steps_1 = require("./steps/adjudication/adjudication-steps");
const exception_review_steps_1 = require("./steps/exception-review/exception-review-steps");
const extract_steps_1 = require("./steps/extract/extract-steps");
const form_steps_1 = require("./steps/forms/form-steps");
const misc_steps_1 = require("./steps/misc/misc-steps");
const mock_steps_1 = require("./steps/mock/mock-steps");
const review_steps_1 = require("./steps/review/review-steps");
exports.WizardUsers = ['ben', 'brandon', 'dimitri', 'jade', 'kira', 'locke', 'margot', 'ryan', 'scott', 'wally'];
var AbortReason;
(function (AbortReason) {
    AbortReason["TooDifficult"] = "TOO_DIFFICULT";
    AbortReason["BadInputs"] = "BAD_INPUTS";
    AbortReason["GottaGo"] = "GOTTA_GO";
    AbortReason["Other"] = "OTHER";
    AbortReason["ClaimExpired"] = "CLAIM_EXPIRED";
    AbortReason["UserCancelledPlan"] = "USER_CANCELLED_PLAN";
    AbortReason["ShortCircuit"] = "SHORT_CIRCUIT";
    AbortReason["SimplifiedFormShortCircuit"] = "sigmaModelEntryFormShortCircuit";
    AbortReason["Unknown"] = "UNKNOWN";
})(AbortReason || (exports.AbortReason = AbortReason = {}));
exports.TestStepDefinitions = {
    TestExtractSignals: test_extract_signals_1.TestExtractSignalsDefinition,
    TestExtractPinout: test_extract_pinout_1.TestExtractPinoutDefinition,
};
exports.TestAndMockStepDefinitions = {
    ...exports.TestStepDefinitions,
    ...mock_steps_1.MockStepDefinitions,
};
exports.StepDefinitions = {
    ...misc_steps_1.MiscStepDefinitions,
    ...extract_steps_1.ExtractStepDefinitions,
    ...review_steps_1.ReviewStepDefinitions,
    ...form_steps_1.FormStepDefinitions,
    ...exception_review_steps_1.ExceptionReviewStepDefinitions,
    ...adjudication_steps_1.AdjudicationStepDefinitions,
    ...exports.TestAndMockStepDefinitions,
};
exports.stepSchema = z.object({
    id: z.string(),
    type: z.string(),
    input: z.record(z.string(), z.any()),
    initialValue: z.record(z.string(), z.any()),
});
//# sourceMappingURL=types.js.map